import React from 'react';
import Ecell from '../Image/Ecell.png';
import classplus from '../Image/classplus.png';
import webd from '../Image/webd.png';
import NIMBUS from '../Image/NIMBUS.png';
import vnit from '../Image/vnit.png';
import SN from '../Image/SN.png';
import {
  MDBCol,
  MDBRow
} from "mdb-react-ui-kit";

const collaborations = [
  { src: Ecell, alt: "E-cell IIT Hyderabad Logo", title: "E-cell IIT Hyderabad Logo" },
  { src: vnit, alt: "VNIT", title: "VNIT" },
  { src: webd, alt: "Webd Logo - Collaboration of InternsElite", title: "Webd Logo - Collaboration of InternsElite" },
  { src: NIMBUS, alt: "NIMBUS NIT Hamirpur Logo", title: "NIMBUS NIT Hamirpur Logo" },
  { src: SN, alt: "Snosft_tech", title: "Snosft_tech" }
];

function Collabration() {
  return (
    <div>
{/* -------------------------------Mobile View-------------------------------- */}        
      <div className="pt-5 d-md-none d-sm-block">
        <div className="container">
          <div className="text-center px-2 mobile_collabration_img">
            <h1>Unleashing Success Through Dynamic Collaborations!</h1>
            <p className="pt-2">
              Experience synergy in action! Explore our impactful partnerships
              with industry leaders, fostering innovation and creating
              unparalleled opportunities for growth. Join us on the path to
              collective success.
            </p>
          </div>
          <div className="container mt-3">
            <div className="row mobile_collabration_img">
              {collaborations.map((collab, index) => (
                <div className='col-12 text-center' key={index}>
                  <img
                    className='my-2'
                    src={collab.src}
                    alt={collab.alt}
                    title={collab.title}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
{/* -------------------------------Desktop View-------------------------------- */}
      <div className="pt-5 d-md-block d-none">
        <div className="container">
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" className="px-5 text-center pt-2 collabration_img">
              <h1 className="display-5">Unleashing Success Through Dynamic Collaborations!</h1>
              <p className="mt-3"> Experience synergy in action! Explore our impactful partnerships
              with industry leaders, fostering innovation and creating
              unparalleled opportunities for growth. Join us on the path to
              collective success.</p>
          </MDBCol>
          </MDBRow>
        </div>
        <div className="container mt-3">
            <div className="row collabration_img">
              <div className='col-2'></div>
              {collaborations.map((collab, index) => (
                <div className='col-2' key={index}>
                  <img
                    className={`text-center ${index < 3 ? 'pt-4' : ''}`}
                    src={collab.src}
                    alt={collab.alt}
                    title={collab.title}
                  />
                </div>
              ))}
              <div className='d-none'></div>
            </div>
          </div>
      </div>
    </div>
  );
}

export default Collabration;